module.exports = __webpack_public_path__ + "static/media/icon-clock-a.e8ebd328.svg";